import BasicText, { IBasicTextProps, ITextVariants } from './BasicText.component';

export default BasicText;
export type { IBasicTextProps, ITextVariants };
